import styled from 'styled-components';

const H2 = styled.h2`
	font-size: 3rem;
	font-weight: 700;
	margin: 0 0 4rem;
	line-height: 1.2;

	@media (min-width: 992px) {
		margin: 0 0 6rem;
		font-size: 4.8rem;
	}
`;

export default H2;
